import { CleanButton, Flex, Icon, breakpoints } from '@gassan-ui'
import { rem } from 'polished'
import { FC, PropsWithChildren, useState } from 'react'
import styled, { css } from 'styled-components'

const Button = styled(CleanButton)<{ isActive?: boolean }>`
  font-family: ${(p) => p.theme.fonts.body};
  padding: 0 1rem;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  font-weight: ${(p) => (p.isActive ? 600 : 400)};
  color: ${(p) => p.theme.colors.shades[800]};
  font-size: ${rem(14)};
  height: 3.5rem;
  @media screen and (min-width: ${breakpoints.small}) {
    height: 4.5rem;
    font-size: ${rem(20)};
    padding: 0 2rem;
  }
`

const Content = styled.div<{ isOpen?: boolean }>`
  padding: 0 1rem;
  max-height: 0;
  height: 0;
  overflow-y: hidden;
  @media screen and (min-width: ${breakpoints.small}) {
    padding: 0 2rem;
  }

  ${(p) =>
    p.isOpen &&
    css`
      max-height: 1200px;
      height: auto;
      padding: 1.5rem 1rem;
      border-top: 1px solid ${(p) => p.theme.colors.shades[200]};
      border-bottom: 1px solid ${(p) => p.theme.colors.shades[200]};
      @media screen and (min-width: ${breakpoints.small}) {
        padding: 1.7rem 2rem;
      }

      &:last-of-type {
        border-bottom: 0;
      }
    `}
`

const Indicator = styled.div`
  font-family: ${(p) => p.theme.fonts.body};
  font-size: ${rem(14)};
  color: #fff;
  border-radius: ${rem(10)};
  font-weight: 600;
  line-height: 1;
  min-width: ${rem(20)};
  height: ${rem(20)};
  margin-left: 0.51rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    background: ${(p) => p.theme.colors.shades[800]};
    z-index: -1;
    position: absolute;
    content: '';
    width: ${rem(20)};
    height: ${rem(20)};
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: ${rem(10)};
  }
`

type Props = PropsWithChildren<{
  label: string
  filterCount: number
}>

const Accordion: FC<Props> = ({ label, children, filterCount }) => {
  const [isOpen, setIsOpen] = useState(filterCount > 0)
  return (
    <>
      <Button isActive={isOpen || filterCount > 0} onClick={() => setIsOpen(!isOpen)}>
        <Flex alignItems="center">
          {label}
          {filterCount > 0 && <Indicator>{filterCount}</Indicator>}
        </Flex>
        <Icon icon={isOpen ? 'chevron-up' : 'chevron-down'} />
      </Button>
      <Content isOpen={isOpen}>{children}</Content>
    </>
  )
}

export default Accordion
